import React from 'react'
import Header from './headers'
import Footer from './footer'
import FooterContact from './footerContact'
import FloatingAction from '../components/shared/floatingAction'
// import { AccountProvider } from '../utils/AccountContext'
const Layout = ({ children }) => {
    return (
        <>
            {/* <AccountProvider> */}
            <Header />
            {children}
            <FloatingAction />
            <FooterContact />
            <Footer />
            {/* </AccountProvider> */}
        </>
    )
}

export default Layout;